import { EmailError, EmailErrorCode } from '../enums/email';

export const EMAIL_ERRORS_MAPPING = {
  [EmailErrorCode.InvalidEmail]: EmailError.InvalidEmail,
  [EmailErrorCode.InvalidDomain]: EmailError.InvalidEmail,
  [EmailErrorCode.RejectedEmail]: EmailError.InvalidEmail,
  [EmailErrorCode.InvalidSMTP]: EmailError.RequestTryAgain,
  [EmailErrorCode.NoConnect]: EmailError.RequestTryAgain,
  [EmailErrorCode.Timeout]: EmailError.RequestTryAgain,
  [EmailErrorCode.UnavailableSMTP]: EmailError.RequestTryAgain,
  [EmailErrorCode.UnexpectedError]: EmailError.RequestTryAgain,
  [EmailErrorCode.UserWithEmailExists]: EmailError.UserWithEmailExists,
};
